import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { debounceTime } from 'rxjs/operators';
import { itemToNameValue, NameValue } from '../../key-value-card/key-value-card.component';
import { ColumnData } from '../../data-table/data-table.component';

@Component({
  selector: 'aberration-info-tab-content',
  templateUrl: './aberration-info-tab-content.component.html',
  styleUrls: ['./aberration-info-tab-content.component.scss']
})
export class AberrationInfoTabContentComponent {

  @Input() annotationsCategories: string[];
  @Input() therapyMatchCategories: string[];
  @Input() clinicalTrialCategories: string[];
  @Input() aberrationExtras: { [key: string]: any};
  @Input() aberration: any;
  @Input() therapyMatches: { [key: string]: any};
  @Input() clinicalTrials: { [key: string]: any};
  @Input() currentModality: string;
  @Input() testTableData: any;
  @Input() configuration: any;
  @Output() scrollLocationChanged: EventEmitter<any> = new EventEmitter();
  @Output() contentUpdated: EventEmitter<any> = new EventEmitter();

  constructor(private elementRef: ElementRef) {
    Observable.fromEvent(elementRef.nativeElement, 'scroll', { capture: true})
      .pipe(debounceTime(600))
      .subscribe(event => {
        const scrollTop = event['target']['scrollTop'] + event['target']['offsetTop'];
        const children = event['target']['children'] as HTMLCollection;
        for (let i = 0; i < children.length; i++) {
          if (children[i]['offsetTop'] <= scrollTop && scrollTop < (children[i]['offsetTop'] + children[i]['clientHeight'])) {
            this.scrollLocationChanged.emit({ id: children[i]['id']});
            break;
          }
        }
      });
  }

  reMapClinicalTrialItem(item) {
    return itemToNameValue(item);
  }

  public resolveAdditionKeyValueItems(dataItem): NameValue[] {

    if (dataItem.stable_cosmic_id) {
      return [{
        name: 'stable_cosmic_id',
        value: dataItem.stable_cosmic_id,
        stableCosmicId: dataItem.stable_cosmic_id,
      }];
    }

  }

  annotationsFormExists(annotationClass: string): boolean {

    if (this.testTableData['editableAnnotations']) {
      const preTranslationCategory = this.aberrationExtras[annotationClass].preTranslationCategory;
      const annotationClasses = this.testTableData['editableAnnotations']['annotationClasses'];
      if (annotationClasses && annotationClasses[preTranslationCategory]) {
        return true;
      }
    }
    return false;
  }

  infoContentUpdated($event) {
    this.contentUpdated.emit($event);
  }

  reMapTranscriptsItem(annotations): ColumnData[] {
    const columns = [];
    const config = this.configuration['transcriptsDataTable'];
    const columnNames = config.columns.map(column => column.name);
    const dataAnnotations = annotations
      .filter(ann => columnNames.indexOf(ann.name) > -1)
      .sort((ann1, ann2) => columnNames.indexOf(ann1.name) - columnNames.indexOf(ann2.name));
    const numOfRows = dataAnnotations[0].value.split(config.delimiter).length;
    let row = 2;
    for (let i = 0; i < numOfRows; i++) {
      let column = 1;
      dataAnnotations.forEach(ann => columns.push({
        row: row,
        column: column++,
        type: config.columns[i].type,
        value: ann.value.split(config.delimiter)[i]
      }));
      row++;
    }
    return columns;
  }
}
